/* tslint:disable max-classes-per-file */
import { decompressJson, padStart } from './utils.js';
import AllEncodingsCompressed from './all-encodings.compressed.json';
const decompressedEncodings = decompressJson(AllEncodingsCompressed);
const allUnicodeMappings = JSON.parse(decompressedEncodings);
class Encoding {
    constructor(name, unicodeMappings) {
        this.canEncodeUnicodeCodePoint = (codePoint) => codePoint in this.unicodeMappings;
        this.encodeUnicodeCodePoint = (codePoint) => {
            const mapped = this.unicodeMappings[codePoint];
            if (!mapped) {
                const str = String.fromCharCode(codePoint);
                const hexCode = `0x${padStart(codePoint.toString(16), 4, '0')}`;
                const msg = `${this.name} cannot encode "${str}" (${hexCode})`;
                throw new Error(msg);
            }
            return { code: mapped[0], name: mapped[1] };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings)
            .map(Number)
            .sort((a, b) => a - b);
        this.unicodeMappings = unicodeMappings;
    }
}
export const Encodings = {
    Symbol: new Encoding('Symbol', allUnicodeMappings.symbol),
    ZapfDingbats: new Encoding('ZapfDingbats', allUnicodeMappings.zapfdingbats),
    WinAnsi: new Encoding('WinAnsi', allUnicodeMappings.win1252),
};
//# sourceMappingURL=Encoding.js.map